// all product component mocks goes in this file..
import choithramsPepsiProductOne from '../../assets/images/product-assets/choithramsPepsiProductOne/choithramsPepsiProductOne.jpg';
import choithramsPepsiProductTwo from '../../assets/images/product-assets/choithramsPepsiProductTwo/choithramsPepsiProductTwo.jpg';
import choithramsPepsiProductThree from '../../assets/images/product-assets/choithramsPepsiProductThree/choithramsPepsiProductThree.jpg';

import choithramsAashirvaadS from '../../assets/images/home-assets/choithramsAashirvaad/choithramsAashirvaadS.png';
import choithramsAlmondsS from '../../assets/images/home-assets/choithramsAlmonds/choithramsAlmondsS.png';
import choithramsChickenMeatBallsS from '../../assets/images/home-assets/choithramsChickenMeatBalls/choithramsChickenMeatBallsS.png';
import choithramsCornFlakesS from '../../assets/images/home-assets/choithramsCornFlakes/choithramsCornFlakesS.png';
import choithramsFaceCreamS from '../../assets/images/home-assets/choithramsFaceCream/choithramsFaceCreamS.png';
import choithramsHairCareS from '../../assets/images/home-assets/choithramsHairCare/choithramsHairCareS.png';
import choithramsJohnsonBabyS from '../../assets/images/home-assets/choithramsJohnsonBaby/choithramsJohnsonBabyS.png';
import choithramsMadhurS from '../../assets/images/home-assets/choithramsMadhur/choithramsMadhurS.png';
import choithramsOrangeS from '../../assets/images/home-assets/choithramsOrange/choithramsOrangeS.png';
import choithramsPetFoodS from '../../assets/images/home-assets/choithramsPetFood/choithramsPetFoodS.png';
import choithramsSafolaS from '../../assets/images/home-assets/choithramsSafola/choithramsSafolaS.png';
import choithramsTataSaltS from '../../assets/images/home-assets/choithramsTataSalt/choithramsTataSaltS.png';

export const dailyDealsFilters = [
  {
    title: 'Vegetables'
  },
  {
    title: 'Fresh'
  },
  {
    title: 'Cooking & Ingredients'
  },
  {
    title: 'Breakfast & Snacks'
  },
  {
    title: 'Frozen'
  },
  {
    title: 'Beverage'
  },
  {
    title: 'Health & Beauty'
  },
  {
    title: 'Baby'
  },
  {
    title: 'House Hold'
  },
  {
    title: 'Pets'
  },
  {
    title: 'Kiosk'
  },
  {
    title: 'Home & Life'
  }
];

export const dailyDealsProducts = [
  {
    'id': 1,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 2,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 3,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 4,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 5,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 6,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 7,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 8,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 9,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 10,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },{
    'id': 11,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 12,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 13,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 14,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 15,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 16,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 17,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 18,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 19,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 20,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 21,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 22,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  }
];

export const filterByCategories = [
  {
      id: 1,
      image: choithramsAashirvaadS,
      title: 'Daily Fresh',
      options: [
        {
          title: 'Apples'
        },
        {
          title: 'Mangoes'
        },
        {
          title: 'Oranges And Kinnow'
        },
        {
          title: 'Banana'
        },
        {
          title: 'Plumps Preaches & Pears'
        },
        {
          title: 'Grapes & Berries'
        },
        {
          title: 'Melons'
        }
      ]
  },
  {
      id: 2,
      image: choithramsAlmondsS,
      title: 'Cooking & Ingredients',
      options: [
        {
          title: 'Apples'
        },
        {
          title: 'Mangoes'
        },
        {
          title: 'Oranges And Kinnow'
        },
        {
          title: 'Banana'
        },
        {
          title: 'Plumps Preaches & Pears'
        },
        {
          title: 'Grapes & Berries'
        },
        {
          title: 'Melons'
        }
      ]
  },
  {
      id: 3,
      image: choithramsChickenMeatBallsS,
      title: 'Beverages',
      options: [
        {
          title: 'Apples'
        },
        {
          title: 'Mangoes'
        },
        {
          title: 'Oranges And Kinnow'
        },
        {
          title: 'Banana'
        },
        {
          title: 'Plumps Preaches & Pears'
        },
        {
          title: 'Grapes & Berries'
        },
        {
          title: 'Melons'
        }
      ]
  },
  {
      id: 4,
      image: choithramsCornFlakesS,
      title: 'Household Needs',
      options: []
  },
  {
      id: 5,
      image: choithramsFaceCreamS,
      title: 'Personal Care',
      options: []
  },
  {
      id: 6,
      image: choithramsHairCareS,
      title: 'Baby & Kids',
      options: []
  },
  {
      id: 7,
      image: choithramsJohnsonBabyS,
      title: 'Bread & Dairy',
      options: []
  },
  {
      id: 8,
      image: choithramsMadhurS,
      title: 'Breakfast & Snacking',
      options: []
  },
  {
      id: 9,
      image: choithramsOrangeS,
      title: 'Household',
      options: []
  },
  {
      id: 10,
      image: choithramsPetFoodS,
      title: 'Pet Food',
      options: []
  },
  {
      id: 11,
      image: choithramsSafolaS,
      title: 'Bread & Dairy',
      options: []
  },
  {
      id: 12,
      image: choithramsTataSaltS,
      title: 'Ready To Cook',
      options: []
  }
];

export const bestDealsFilters = [
  {
    title: 'Vegetables'
  },
  {
    title: 'Fresh'
  },
  {
    title: 'Cooking & Ingredients'
  },
  {
    title: 'Breakfast & Snacks'
  },
  {
    title: 'Frozen'
  },
  {
    title: 'Beverage'
  },
  {
    title: 'Health & Beauty'
  },
  {
    title: 'Baby'
  },
  {
    title: 'House Hold'
  },
  {
    title: 'Pets'
  },
  {
    title: 'Kiosk'
  },
  {
    title: 'Home & Life'
  }
];

export const bestDealsProducts = [
  {
    'id': 1,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 2,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 3,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 4,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 5,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 6,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  }
];

export const buyAndGetFreeFilters = [
  {
    title: 'Vegetables'
  },
  {
    title: 'Fresh'
  },
  {
    title: 'Cooking & Ingredients'
  },
  {
    title: 'Breakfast & Snacks'
  },
  {
    title: 'Frozen'
  },
  {
    title: 'Beverage'
  },
  {
    title: 'Health & Beauty'
  },
  {
    title: 'Baby'
  },
  {
    title: 'House Hold'
  },
  {
    title: 'Pets'
  },
  {
    title: 'Kiosk'
  },
  {
    title: 'Home & Life'
  }
];

export const buyAndGetFreeProducts = [
  {
    'id': 1,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 2,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 3,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 4,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 5,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 6,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  }
];

export const productListProducts = [
  {
    'id': 1,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 2,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 3,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 4,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 5,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 6,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  }
];

export const recentlyViewedProducts = [
  {
    'id': 1,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 2,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 3,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 4,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 5,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 6,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  }
];

export const saveMaxFilters = [
  {
    title: 'Vegetables'
  },
  {
    title: 'Fresh'
  },
  {
    title: 'Cooking & Ingredients'
  },
  {
    title: 'Breakfast & Snacks'
  },
  {
    title: 'Frozen'
  },
  {
    title: 'Beverage'
  },
  {
    title: 'Health & Beauty'
  },
  {
    title: 'Baby'
  },
  {
    title: 'House Hold'
  },
  {
    title: 'Pets'
  },
  {
    title: 'Kiosk'
  },
  {
    title: 'Home & Life'
  }
];

export const saveMaxProducts = [
  {
    'id': 1,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 2,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 3,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 4,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 5,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 6,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  }
];

export const shopHighlightsFilters = [
  {
    title: 'Vegetables'
  },
  {
    title: 'Fresh'
  },
  {
    title: 'Cooking & Ingredients'
  },
  {
    title: 'Breakfast & Snacks'
  },
  {
    title: 'Frozen'
  },
  {
    title: 'Beverage'
  },
  {
    title: 'Health & Beauty'
  },
  {
    title: 'Baby'
  },
  {
    title: 'House Hold'
  },
  {
    title: 'Pets'
  },
  {
    title: 'Kiosk'
  },
  {
    title: 'Home & Life'
  }
];

export const shopHighlightsProducts = [
  {
    'id': 1,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 2,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 3,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 4,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 5,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 6,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  }
];

export const topSellerFilters = [
  {
    title: 'Vegetables'
  },
  {
    title: 'Fresh'
  },
  {
    title: 'Cooking & Ingredients'
  },
  {
    title: 'Breakfast & Snacks'
  },
  {
    title: 'Frozen'
  },
  {
    title: 'Beverage'
  },
  {
    title: 'Health & Beauty'
  },
  {
    title: 'Baby'
  },
  {
    title: 'House Hold'
  },
  {
    title: 'Pets'
  },
  {
    title: 'Kiosk'
  },
  {
    title: 'Home & Life'
  }
];

export const topSellerProducts = [
  {
    'id': 1,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 2,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 3,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 4,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 5,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 6,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  }
];

export const brandProductsFilters = [
  {
    title: 'Vegetables'
  },
  {
    title: 'Fresh'
  },
  {
    title: 'Cooking & Ingredients'
  },
  {
    title: 'Breakfast & Snacks'
  },
  {
    title: 'Frozen'
  },
  {
    title: 'Beverage'
  },
  {
    title: 'Health & Beauty'
  },
  {
    title: 'Baby'
  },
  {
    title: 'House Hold'
  },
  {
    title: 'Pets'
  },
  {
    title: 'Kiosk'
  },
  {
    title: 'Home & Life'
  }
];

export const brandProducts = [
  {
    'id': 1,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 2,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 3,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 4,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductOne,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 5,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductTwo,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  },
  {
    'id': 6,
    'productTitle': 'Pepsi, Carbonated Soft Drink, Cans',
    'productImage': choithramsPepsiProductThree,
    'productCurrency': 'AED',
    'productPrice': '13.50',
    'productMarketPrice': 'Was 18.50',
    'productMyLists': [
      {
        title: 'Default',
        count: 'My First List'
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      },{
        title: 'Kids Party List',
        count: 15
      },{
        title: `Saturday's BBQ`,
        count: 22
      },{
        title: `Thanks Giving`,
        count: 8
      }
    ],
    'productCount': 2,
    'productQuantity': '1.8L + 500ml',
    'productOffer': '@ 25% off'
  }
];
